import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'System|Localization|Dialog';

type InliningLocalizationLocs =
	| 'CMSystemLocalizationDialogModificationWarning'
	| 'CMSystemLocalizationNoValueSet';

export const inliningLocalizationLocs: LocDefs<InliningLocalizationLocs> = {
	CMSystemLocalizationDialogModificationWarning: {
		defaultValue:
			'Your localization code may have been modified for security reasons. Please verify the result.',
		displayPath: `${dpRoot}|Code Modified`,
		description:
			'Message shown when code has been changed in the localization modal, indicating that it may have been updated for security and the new defaultValue needs tested.',
		displayType: 'Notification',
		portal: 'All',
	},
	CMSystemLocalizationNoValueSet: {
		defaultValue: 'No Localization Set',
		displayPath: `System|Localization|No Value Set`,
		description: 'Message shown when a localization has no default or localized value.',
		displayType: 'Content',
		portal: 'All',
	},
};

export const GLOBAL_LOCALIZATION_KEYS =
	MapLocKeys<InliningLocalizationLocs>(inliningLocalizationLocs);
export type InliningLocType = LocMap<InliningLocalizationLocs>;
